import { createRequestTypes } from './utils';
import SsoApi from '../api/SsoApi';
export const FETCH_SSO_SETTINGS = 'FETCH_SSO_SETTINGS';
export const FetchSsoActionTypes = createRequestTypes(FETCH_SSO_SETTINGS);
export const fetchSsoSettings = () => dispatch => {
  dispatch({
    type: FetchSsoActionTypes.REQUEST
  });
  SsoApi.getSamlSettings().then(response => {
    dispatch({
      type: FetchSsoActionTypes.SUCCESS,
      payload: response
    });
  }).catch(error => {
    dispatch({
      type: FetchSsoActionTypes.FAILURE,
      payload: error
    });
  });
};